import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import { unzipSync } from 'zlib';
import { connected } from 'process';
import format from 'date-fns/format'
import { getUserAll } from './core/cacheService'
export default {
    namespaced: true,
    state: {
        sparkHappily:[],
        sparkHappilyloading: false,
        sparkCustom:[],
        sparkStatus:false,
        cardId:'',
        customClass:[],
        sparkType:[],
        dataSparkTypeName:{},
        loading:false
    },
    mutations: {
        setSparkHappily(state: any, result: any) {
            state.sparkHappily = result
        },
        setSparkHappilyloading(state: any, result: any) {
            state.sparkHappilyloading = result
        },
        setSparkCustom(state: any, result: any) {
            state.sparkCustom = result
        },
        setSparkStatus(state: any, result: any) {
            state.sparkStatus = result
        },
        setCardId(state: any, result: any) {
            state.cardId = result
        },
        setCustomClass(state: any, result: any) {
            state.customClass = result
        },
        setSparkType(state: any, result: any) {
            state.sparkType = result
        },
        setSparkTypeName(state: any, result: any) {
            state.dataSparkTypeName = result
        },
        setLoading(state: any, result: any) {
            state.loading = result
        },
    },
    actions: {
        async checkSetName({ commit, state }: any,{name,user}:any) {
            commit('setSparkStatus',false)

            await firebase.database().ref('spark_set').orderByChild('name').equalTo(name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
               
            },
        async getSparkHappily({ commit, state,dispatch }: any,data:any) {
       
        const dataSparkSet:Array<any> = [];
        commit('setSparkHappilyloading', true);
        await firebase.database().ref('spark_set').once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    let cardList:Array<any> = [];
                    const _data = childSnapshot.val();
                    if(_data.companyId===undefined||_data.companyId===data.company)
                    {
                   
                    firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                    .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        cardList.push({...data,sparkTitle:data.name,id:doc.id})
                    })})
                    dataSparkSet.push({
                        ..._data,
                        cardList,
                        customSet: _data.customSet===undefined?0:_data.customSet,
                        id:childSnapshot.key,
                        happilySet:_data.order===undefined?_data.happilySet:_data.order,
                        type:_data.companyId===undefined?'happily':'custom',
                        permissions: ["Everyone"],})
                    }
                })
            })
             const sort_List = _.sortBy(dataSparkSet, ["happilySet", "customSet"]);
            commit('setSparkHappilyloading', false);
            //console.log('sort_List',sort_List)
            commit('setSparkHappily', sort_List)
           
        },
        async getSparkCustom({ commit, state }: any,data:any) {
            const dataSparkSetCustom:Array<any> = [];
           await firebase.database().ref('spark_set').orderByChild('companyId').equalTo(data.company).once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const cardList:Array<any> = [];
                        const _data = childSnapshot.val(); 
                            firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                            .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                // console.log("data",data)
                                cardList.push({...data,sparkTitle:data.name,id:doc.id})
                            })})
                            dataSparkSetCustom.push({
                                ..._data,
                                cardList,
                                customSet: _data.customSet===undefined?0:_data.customSet,
                                id:childSnapshot.key,
                                happilySet:_data.order===undefined?_data.happilySet:_data.order,
                                type:_data.companyId===undefined?'happily':'custom',
                                permissions: ["Everyone"],}) 
                        })
                    
                })
                //console.log('dataSparkSetCustom',dataSparkSetCustom)
                commit('setSparkCustom', dataSparkSetCustom)
               
            },
        async createSparkSetCustom({ commit, state }: any,data:any){
                firebase.database().ref("spark_set").push(data)
        },
        async updateSetNameSparkCustom({ commit, state,dispatch, rootState}: any,{data,user}:any){
            commit('setSparkStatus',false)
            await firebase.database().ref('spark_set').orderByChild('name').equalTo(data.name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
            if(!state.sparkStatus)
            {
                await firebase.database().ref(`spark_set/${data.id}`).update({name:data.name});
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
                commit('setSparkStatus',false)
            }
           
        },
        async updatePositionsSparkCustom({ commit, state ,dispatch,rootState}: any,data:any){ 
            await firebase.database().ref(`spark_set/${data.id}`).update({customSet: data.customSet,happilySet: data.happilySet}).then(()=>{
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            });

        },
        async updateSparkCustom({ commit, state,dispatch,rootState }: any,data:any){  
                await firebase.database().ref(`spark_set/${data.id}`).update(data).then(()=>{
                /*save logs*/
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: data.id,
                        table: 'spark_set',
                        status: 'update',
                        user: rootState.authen.user.email
                    }, {root:true})
                });

        },
        deleteSparkCustom({ commit, state,rootState,dispatch }: any,data:any){  
            firebase.database().ref(`spark_set/${data.id}`).remove().then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
            })
            firebase.firestore().collection("spark_class").where('set', '==', data.id).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                  doc.ref.delete();
                });
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
              });
        },
        deleteSparkCustomClass({ commit, state ,rootState,dispatch}: any,data:any){  
             firebase.firestore().collection("spark_class").doc(data.id).delete().then(() => {
               /*save logs*/
               dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: data.id,
                table: 'spark_class',
                status: 'delete',
                user: rootState.authen.user.email
            }, {root:true})
            })
        },
        async createSparkCustomClass({ commit, state }: any,data:any){  
           await firebase.firestore().collection("spark_class").add(data).then((docRef) => {
               
                commit('setCardId', docRef.id)
                
            })
        },
        updateSpartCustomClass({ commit, state ,dispatch,rootState}: any,{id,data}:any){  
            firebase.firestore().collection(`spark_class`).doc(id).update(data).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            })
        },
        async getSparkType({ commit, state }: any) {
            const dataSparkType:Array<any> = [];
            const dataSparkTypeName= {};
            await firebase.database().ref('spark_type').once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const _data = childSnapshot.val();
                        
                        if(_data.image!==undefined)
                        {
                            dataSparkType.push({..._data,id:childSnapshot.key})
                            if(!dataSparkTypeName[_data.name])
                            {
                                dataSparkTypeName[_data.name]=_data
                                dataSparkTypeName[_data.name].id=childSnapshot.key
                            }
                        }
                    })
                })
                //console.log('dataSparkTypeName',dataSparkTypeName)
                commit('setSparkType', dataSparkType)
                commit('setSparkTypeName', dataSparkTypeName)
               
        },
        async genSparkSetAI({ commit, state,rootState,dispatch}: any,data:any){
           
            var axios = require('axios');
            const dataSparkTypeName=state.dataSparkTypeName
            const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
            let userLanguage=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            userLanguage=_.groupBy(userLanguage,'language')
            let languages:Array<any>=[]
            const lang_code={}
            for(const i in userLanguage){

                if(materlanguage[i]){
                    languages.push(materlanguage[i].name)
                    lang_code[materlanguage[i].name]=materlanguage[i].code
                }
            }
            

            //console.log('languages',languages.toString())
            //languages=['English']
            const url=`https://api-node.happily.ai/openai/skill_set_ai?skill=${data.skill}&lang=[${languages.toString()}]`
           // const url=`http://localhost:80/openai/skill_set_ai?skill=${data.skill}&lang=[${languages.toString()}]`
           console.log('url',url)
           const config = {
            method: 'post',
           
            url: url,
          };
            const response = await axios(config)
            // const response = await axios.get(url)
           
            let newid :any =''
            const cardList:Array<any>=[]
            let cardRank={}
            //console.log('response',response.data)
            let newSet={}
            for(const lang in response.data){
               
                const obj = JSON.parse(response.data[lang]); 
                console.log('obj',obj)
                const jsonData=JSON.parse(obj)

                //console.log('jsonData',jsonData)
                const langName=lang
                const langCode=lang_code[langName]
               
            
                 
                if(langName=='English'){
                    newid=firebase.database().ref("spark_set").push().key
                    newSet={
                            name: jsonData.setName,
                            permissions:['Everyone'],
                            happilySet: data.happilySet,
                            customSet:data.customSet+1,
                            companyId:rootState.authen.user.company,

                    }
                    const insert={}
                    insert[newid] = newSet;
                    //console.log('insert',insert)
                    firebase.database().ref('spark_set').update(insert);
                   
                }
                let count=0
                for(const card in jsonData.cards){
                    //content_[]
                    
                    if(!cardRank[count]){
                        cardRank[count]={}                  
                    }
                    cardRank[count][`content_${langCode}`]=jsonData.cards[card].body+'<br>'+jsonData.cards[card].nudge
                    if(langName=='English'){
                        cardList.push({
                            name:jsonData.cards[card].title,
                            order:Number(card)+1,
                            type:dataSparkTypeName[jsonData.cards[card].icon].id,
                            set:newid,
                            sparkTitle:jsonData.cards[card].title
                        })
                    }
                count++
                }

            }
            for(const card in cardList){
                if(cardRank[card]){
                    cardList[card]={...cardList[card],...cardRank[card],updated:format(new Date(), 'YYYY-MM-DD HH:mm:ss')}
                }
                const id_card=await firebase.firestore().collection("spark_class").add(cardList[card])
                cardList[card].id=id_card.id
            }   
            //console.log('cardList',cardList)
            
            return {cardList:cardList,id:newid,...newSet}
        }
    },
    getters: {
        sparkHappily:(state: any) => {
            return state.sparkHappily
        },
        sparkHappilyloading:(state: any) => {
            return state.sparkHappilyloading
        },
        sparkCustom:(state: any) => {
            return state.sparkCustom
        },
        sparkStatus(state: any, result: any) {
            return state.sparkStatus
        },
        cardId(state: any, result: any) {
            return state.cardId
        },
        customClass(state: any, result: any) {
            return state.customClass
        },
        sparkType:(state: any) => {
            return state.sparkType
        },

    }
}